import { ImContent, ImMessage, TemplateTypes, Types } from "./Cmd";
import { getUuidV4 } from "@/utils/utils";

export function initMessage(msgType: Types,sessionId: number,data:ImContent,time?:number): ImMessage | null {
    switch(msgType) {
        case Types.MSG_TEXT:
            return initText(sessionId,data,time);
            break;
        case Types.MSG_IMAGE:
            return initImage(sessionId,data,time);
            break;
        default:
            return null;
    } 
}

function initText(sessionId: number,data:ImContent,time?:number): ImMessage | null {
    try{
        if (!data.text) return null;
        let seq = getUuidV4();
        let content:ImContent = {
            code:"TEXT",
            text:data.text
        }
        let message: ImMessage = {
            seq: seq,
            sessionId: sessionId,
            msgType:Types.MSG_TEXT,
            content:content,
            status:0,
            createTime:time
        }
        return message;
    }catch(err){
        return null;
    }
}

function initImage(sessionId: number,data:ImContent,time?:number): ImMessage | null {
    try{
        if (!data.url) return null;
        let seq = getUuidV4();
        let content:ImContent = {
            code:"IMAGE",
            url:data.url
        }
        let message: ImMessage = {
            seq: seq,
            sessionId: sessionId,
            msgType:Types.MSG_IMAGE,
            content:content,
            status:0,
            createTime:time
        }
        return message;
    }catch(err){
        return null;
    }
}

export function initTemplate(templateType: TemplateTypes,sessionId: number,data:any,time?:number): ImMessage | null {
    if(templateType == TemplateTypes.JOB_INFO){
        return initJob(sessionId,data,time);
    }else{
        return initModel(sessionId,data,time);
    }
}

function initJob(sessionId: number,data:any,time?:number): ImMessage | null {
    try{
        if (!data.id || !data.careerTitle || !data.remarks || !data.createTime) return null;
        let seq = getUuidV4();
        let content:ImContent = {
            id:data.id,
            code:TemplateTypes.JOB_INFO,
            title:data.careerTitle,
            content:data.remarks,
            min:data.salaryMin,
            max:data.salaryMax,
            time:data.createTime
        }
        let message: ImMessage = {
            seq: seq,
            sessionId: sessionId,
            msgType:Types.MSG_TEMPLATE,
            content:content,
            status:0,
            createTime:time
        }
        return message;
    }catch(err){
        return null;
    }
}

function initModel(sessionId: number,data:any,time?:number): ImMessage | null {
    try{
        if (!data.code || !data.title || !data.content) return null;
        let seq = getUuidV4();
        let content:ImContent = {
            code:data.code,
            title:data.title,
            content:data.content,
            subTitle:data.subTitle,
            url:data.url,
            linkText:data.linkText,
            linkType:data.linkType,
            path:data.path
        }
        let message: ImMessage = {
            seq: seq,
            sessionId: sessionId,
            msgType:Types.MSG_TEMPLATE,
            content:content,
            status:0,
            createTime:time
        }
        return message;
    }catch(err){
        return null;
    }
}



export function setImMessage(session: any,message: ImMessage | null): ImMessage | null {
    if (!session || !message) return null;
    let currentUser = session.currentUser;
    let contactUser = session.contactUser;
    message.fromId = currentUser.userId;
    message.fromType = currentUser.userType;
    message.fromHead = currentUser.head;
    message.fromName = currentUser.username;
    if (session.imType == 1){
        message.toId = contactUser.userId;
        message.toType = contactUser.userType;
        message.toHead = contactUser.head;
        message.toName = contactUser.username;
    }
    return message;
}